import Link                                                      from "next/link";
import { Trophy, Users, Sword, ChevronRight }                    from "lucide-react";
import heroBanner                                                from "@/assets/img/banner.jpg";
import Image                                                     from 'next/image'

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src={heroBanner}
          alt="Void Legions"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/50 via-transparent to-background/50" />
      </div>

      {/* Particles Overlay */}
      <div className="absolute inset-0 particles-bg z-10" />

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 text-center">
        <div className="animate-float">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 border border-primary/30 mb-6">
            <Sword className="w-4 h-4 text-primary" />
            <span className="text-sm font-rajdhani text-primary-foreground">
              Void Legions RPG · Nível, patentes e Reis
            </span>
          </div>
        </div>

        <h1 className="font-orbitron text-5xl md:text-7xl lg:text-8xl font-black text-neon mb-4">
          VOID LEGIONS
        </h1>

        <p className="text-xl md:text-2xl font-rajdhani text-muted-foreground max-w-2xl mx-auto mb-8">
          Suba de nível com cada evento, raid, PvP e quiz no Blox Fruits.
          <br />
          Ganhe XP, conquiste patentes e dispute o trono dos Reis.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            href="/rankings"
            className="group flex items-center gap-2 px-8 py-4 rounded-xl bg-gradient-void text-primary-foreground font-orbitron font-bold tracking-wide transition-all duration-300 hover:scale-105 void-glow-intense"
          >
            <Trophy className="w-5 h-5" />
            Ver Rankings
            <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>

          <Link
            href="/crews"
            className="group flex items-center gap-2 px-8 py-4 rounded-xl border-2 border-primary/50 text-foreground font-orbitron font-bold tracking-wide transition-all duration-300 hover:bg-primary/10 hover:border-primary"
          >
            <Users className="w-5 h-5" />
            Explorar Crews
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-primary/50 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-primary animate-pulse" />
        </div>
      </div>
    </section>
  );
}
